/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // NPM: Apollo client for handling graphql request.

/*
 * GRAPH
 */
const Index = gql`
  mutation MyMutation($contentDetailId: ID!, $tailerVideoLink: String!) {
    UploadTrailer(
      contentDetailId: $contentDetailId
      tailerVideoLink: $tailerVideoLink
    ) {
      message
      status
    }
  }
`;

/*
 * EXPORTS
 */
export default Index;
